<template>
	<div>
		<transition name="fade">
			<Row v-if="mainTable.sarchShow" :gutter="16">
				<Col span="24">
				<search-card :form="mainTable.searchForm" :table-load-event="getTableRecords"
					:table-search="mainTable.tableSearch" />
				</Col>
			</Row>
		</transition>
		<Card :padding="0" :bordered="false" :dis-hover="true">
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">总监角色列表</span>
					</div>
					<div class="right-bar">
						<Button v-if="$checkAccessArray(['S'])" size="small" class="btns" shape="circle" type="success"
							icon="ios-add-circle-outline" @click="onCreate">新增</Button>
						<Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
							@click="mainTable.sarchShow = !mainTable.sarchShow">搜索</Button>
					</div>
				</div>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table :columns="mainTable.columns" :data="mainTable.data" :extHeight="60"
					:loading="mainTable.loading" :table-search="mainTable.tableSearch"
					:table-load-event="getTableRecords" />
				</Col>
			</Row>
		</Card>

		<RoleInspectorEdit ref="roleInspectorModal" />
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import {
    statusNewFormat
} from '@/libs/baseModelFormat';
import {
    dateRender
} from '@/libs/tableRowTimeRender';
import RoleInspectorEdit from './role-inspector-edit';
import {
    getRoleList
} from '@/api/modules/account-management/inspector-user-management';

export default {
    name: 'RoleInspectorList',
    components: {
        SearchCard,
        StandPaginationTable,
        RoleInspectorEdit
    },
    data() {
        return {
            mainTable: {
                columns: [{
                    title: '行号',
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '账号',
                    key: 'userNames',
                    align: 'center'
                },
                {
                    title: '角色名称',
                    key: 'name',
                    align: 'center'
                },
                {
                    title: '状态',
                    key: 'recordStatus',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('span', {}, statusNewFormat(params.row.recordStatus))
                        ]);
                    }
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    render: (h, params) => dateRender(h, params.row.createTime)
                },
                {
                    title: '更新时间',
                    key: 'modifyTime',
                    align: 'center',
                    render: (h, params) => dateRender(h, params.row.modifyTime)
                },
                {
                    title: '操作',
                    key: 'action',
                    align: 'center',
                    width: 80,
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {},
                                on: {
                                    click: () => {
                                        this.onUpdate(params.row);
                                    }
                                }
                            }, '编辑')
                        ]);
                    }
                }
                ],
                data: [],
                sarchShow: false,
                searchForm: [{
                    label: '角色名称',
                    type: 'Input',
                    value: '',
                    name: 'name',
                    sql: 'like'
                },
                {
                    label: '状态',
                    type: 'Select',
                    name: 'recordStatus',
                    sql: 'in',
                    options: [{
                        value: 1,
                        key: '启用'
                    }, {
                        value: 0,
                        key: '停用'
                    }]
                }

                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getTableRecords();
    },
    methods: {
        getTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.type = '总监';
            getRoleList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreate() {
            this.$refs.roleInspectorModal.showModal('');
        },
        onUpdate(row) {
            this.$refs.roleInspectorModal.showModal(row.roleUuid);
        }
    }
};
</script>

<style scoped>
</style>
